<template>
  <div class="personIndex">
    <div class="pageContent message">
      <div class="pageFlexBetween header">
        <IconLeftWord :word="info.userPhone" iconName="iconuser" color="#fff" />
        <!-- <div class="member" @click="$push({path:'/member'})" v-if="(info.plusvip_expire_date==null||info.plusvip_expire_date=='')&$route.name!='Member'"><van-icon name="vip-card" size="20"  style=""/>会员购买</div> 
        <div class="member" @click="$push({path:'/member'})" v-if="info.plusvip_expire_date!=null&info.plusvip_expire_date!=''"><van-icon name="vip-card" size="20"  style=""/>会员到期时间：{{info.plusvip_expire_date}}</div>         -->
      </div>
      <div class="pageCard detail" :style="{backgroundImage: 'url(' + bgImg +')'}">
        <!-- <KImg :src='bgImg' /> -->
        <div class="pageFlex detailContent">
          <!-- <div class="balance">
            <p class="pageFontWeight">{{info.balance}}</p>
            <span>余额</span>
          </div> --> 
          <div class="balance coupon"  >
            <p class="pageFontWeight couponP">{{count}}</p>
            <span>卡券</span>
          </div>
          <div
            v-if="showRechargeBtn"
            class="pageHalfRadius pageFontWeight btn"
            @click="handleClick"
          >卡券领取/绑定</div>
        </div>
      </div>
    </div>
    <div
      :style="$getItem('appId')=='wx1a49bf0dfec9b834'||$getItem('appId')=='wx5099255b7d375c60'?'padding-bottom:150px;':''"
      class="pageFooterPage content"
    >
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showRechargeBtn: Boolean,
    showClear: {
      type: Boolean,
      default: () => false,
    },
    info: {
      type: Object,
      default: () => {},
    },
    isIf: {
      type: String,
      default: () => "",
    },
    count:{
      type:Number,
      default:()=>0
    }
  },
  data() {
    return {
      bgImg: require("assets/u602.png"),
      isShow: false,
    };
  },
  mounted() {
    //  console.log(this.$route);
  },
  methods: {
    handleClick() {
      this.$push({
        name: "recharge",
      });
    },
  },
};
</script>

<style scoped lang="less">
.personIndex {
  .title {
    margin-top: 0px;
    padding-top: 20px;
  }
  .message {
    overflow: hidden;
    background: linear-gradient(
      180deg,
      var(--depYelColor) 0%,
      var(--depYelColor) 100%
    );
    .header {
      height: 40px;
      margin-top: 4px;
      .iconfont {
        color: #fff;
        font-size: 18px;
        margin-left: 4px;
      }
      /deep/.iconuser {
        font-size: 22px;
        margin-right: 0px;
      }
      .clear {
        font-size: 14px;
        color: #fff;
      }
      .member {
        display:flex;
        font-size: 14px;
        color: #fff;
      }
    }
    .detail {
      padding: 20px;
      background-repeat: no-repeat;
      background-position: 97% 0;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
      .kimg {
        width: 40%;
        float: right;
      }
      .detailContent {
        font-size: var(--smallFont);
        color: var(--depHidColor);
        .balance {
          p {
            font-size: 26px;
            color: var(--depYelColor);
          }
          .couponP {
            color: var(--depBlueColor);
          }
        }
        .line {
          width: 1px;
          height: 40px;
          margin: 0 20px;
          background: var(--lineColor);
        }
        .btn {
          border: 2px solid var(--depYelColor);
          margin-left: auto;
          color: var(--depYelColor);
          background: #fff;
          font-size: var(--pFont);
          padding: 6px 8px;
          word-break: break-all;
        }
      }
    }
  }
  .content {
    position: relative;
    background: var(--bgColor);
    box-shadow: 0px -5px 5px rgba(85, 85, 85, 0.1);
  }
}
</style>
